import React from 'react';
import BackgroundMusic from 'utils/BackgroundMusic';
import backgroundMusic from './background-music.mp3';

const BACKGROUND_MUSIC_OPTIONS = {
  src: [backgroundMusic],
  sprite: {
    loop: [0, 148200]
  },
  loop: true,
  volume: 0,
  finalVolume: 0.05
};

function ThemeMusic({ authenticated }) {
  return (
    <BackgroundMusic
      priority={0}
      options={BACKGROUND_MUSIC_OPTIONS}
      enabled={authenticated}
    />
  );
}

export default ThemeMusic;
